import { Navigate } from "react-router-dom";
import { isLoggedIn } from "./utils/util";

const PrivatePath = ({ children }) => {
    if (!isLoggedIn()) {
        return <Navigate to="/login" replace />;
    }
    return children;
};
export default PrivatePath 